import React, { FunctionComponent } from 'react';
import useFlashMessage from '@/hooks/useFlashMessage';
import FlashMessage from '../design/FlashMessage';

interface IProps {}

const DisplayFlashMessages: FunctionComponent<IProps> = () => {
  const { flashMessages, removeFlashMessage } = useFlashMessage();
  return (
    <div>
      {flashMessages.map((flashMessage) => (
        <FlashMessage
          closable
          type={flashMessage.type}
          message={flashMessage.message}
          onClose={() => {
            removeFlashMessage(flashMessage.uuid, flashMessages);
          }}
          key={flashMessage.uuid}
        />
      ))}
    </div>
  );
};

export default DisplayFlashMessages;
